module.exports = __webpack_public_path__ + "static/img/light.bf4351b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/light.png
// module id = 2oW9
// module chunks = 1